import styled from 'styled-components';

export const LastExecutionBarStyled = styled.div`
  height: 40px;
  background-color: var(
    --ds-background-accent-gray-subtlest,
    var(--ds-fb-background-accent-gray-subtlest)
  );
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px 0 30px;
`;

export const LastExecutionStatusStyled = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const LastExecutionTextSubtleStyled = styled.div`
  color: var(--ds-text-subtle, var(--ds-fb-text-subtle));
  font-weight: 450;
  font-size: 12px;
`;

export const LastExecutionTextStyled = styled.div`
  color: var(--ds-text, var(--ds-fb-text));
`;

export const LastExecutionButtonsStyled = styled.div`
  display: flex;
  align-items: center;
`;
